// Global UI density (small / medium / large). Admin controls it via
// settings/ui-density; every page reads the resolved multiplier.
import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const STORAGE_KEY = "kh_ui_density";
const DensityContext = createContext("medium");

const SCALES = { small: 0.9, medium: 1.0, large: 1.15 };

export function UIDensityProvider({ children }) {
  const [density, setDensity] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "medium"; }
    catch { return "medium"; }
  });

  useEffect(() => {
    api.get("/settings/ui-density").then(r => {
      const next = (r.data?.density || "medium").toLowerCase();
      if (SCALES[next]) {
        setDensity(next);
        try { localStorage.setItem(STORAGE_KEY, next); } catch { /* quota */ }
      }
    }).catch(() => {});
  }, []);

  // Apply as a CSS variable + <html> attribute so Tailwind arbitrary values
  // and plain CSS can both scale from a single source of truth.
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--ui-scale", String(SCALES[density] || 1));
    root.setAttribute("data-density", density);
  }, [density]);

  return <DensityContext.Provider value={density}>{children}</DensityContext.Provider>;
}

export const useUIDensity = () => useContext(DensityContext);
